// extracted by mini-css-extract-plugin
module.exports = {"warrantyFooter":"az_FXc","azWarranty":"az_GXc"};